import { render, staticRenderFns } from "./userInfoBox.vue?vue&type=template&id=104f41b4&scoped=true&"
import script from "./userInfoBox.vue?vue&type=script&lang=js&"
export * from "./userInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./userInfoBox.vue?vue&type=style&index=0&id=104f41b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104f41b4",
  null
  
)

export default component.exports